import dayjs from "dayjs";
import { Button, Table } from "react-bootstrap";
import CopyButton from "../../../../components/copyButton/CopyButton";
import { DateFormats } from "../../../../utilities/dates";
import { convertMediaSourceToCsvData, downloadCsvFile } from "../../../../utilities/export/csv";
import { ReviewVideoListItemTrayContentProps } from "./ReviewVideoListItemFooter";

export default function ReviewVideoListItemDetails(props: ReviewVideoListItemTrayContentProps) {
    // Details
    const startTime = dayjs(props.data.startsAt).format(DateFormats.dayMonthYearWithTimeSeconds);
    const endTime = dayjs(props.data.startsAt + props.data.duration).format(DateFormats.dayMonthYearWithTimeSeconds);
    const duration = dayjs.duration(props.data.duration).format(DateFormats.durationTimeDaysToMillisecondsAlt);
    const id = props.data.mediaId;
    const createdAt = dayjs(props.data.createdAt).format(DateFormats.dayMonthYearWithTimeSeconds);
    const createdBy = props.data.createdBy?.id ?? "???";

    // Metadata
    const initialDisplay = props.data.files.initialDisplay;
    const { width, height, frameRate } = initialDisplay || {};

    function onClickExportToCsv() {
        const data = convertMediaSourceToCsvData(props.data);
        downloadCsvFile(data, `${props.data.name} - video details`);
    }

    function getTimeZoneOffset(timezone: string) {
        const offset = dayjs.tz(dayjs(props.data.startsAt), timezone).utcOffset();
        return offset >= 0 ? `+${offset / 60}` : `${offset / 60}`;
    }

    return (
        <div className="gap-1 inner d-flex flex-column">
            <section className="overflow-hidden">
                <Table borderless className="details-table">
                    <tbody>
                        <tr>
                            <td>Start Time</td>
                            <td className="w-100">{startTime}</td>
                            <td>
                                <CopyButton toCopy={startTime} />
                            </td>
                        </tr>
                        <tr>
                            <td>End Time</td>
                            <td>{endTime}</td>
                            <td>
                                <CopyButton toCopy={endTime} />
                            </td>
                        </tr>
                        <tr>
                            <td>Time Zone</td>
                            <td>
                                GMT{getTimeZoneOffset(props.data.timezone)}
                                <span style={{ fontSize: "smaller" }}> ({props.data.timezone})</span>
                            </td>
                            <td>
                                <CopyButton toCopy={props.data.timezone} />
                            </td>
                        </tr>
                        <tr>
                            <td>Duration</td>
                            <td>{duration}</td>
                            <td>
                                <CopyButton toCopy={duration} />
                            </td>
                        </tr>
                        <tr>
                            <td>Created At</td>
                            <td className="w-100">{createdAt}</td>
                            <td>
                                <CopyButton toCopy={createdAt} />
                            </td>
                        </tr>
                        <tr>
                            <td>Created By</td>
                            <td>{createdBy}</td>
                            <td>
                                <CopyButton toCopy={createdBy} />
                            </td>
                        </tr>
                        <tr>
                            <td>ID</td>
                            <td>{id}</td>
                            <td>
                                <CopyButton toCopy={id} />
                            </td>
                        </tr>
                        {!initialDisplay && (
                            <tr>
                                <td colSpan={3} className="text-muted text-center">
                                    <div style={{ marginTop: "0.8rem", opacity: 0.6 }}>Video metadata unavailable</div>
                                </td>
                            </tr>
                        )}

                        {initialDisplay && height && width && (
                            <tr>
                                <td>Resolution</td>
                                <td>{`${width}x${height}`}</td>
                                <td>
                                    <CopyButton toCopy={`${width}x${height}`} />
                                </td>
                            </tr>
                        )}

                        {initialDisplay && frameRate && (
                            <tr>
                                <td>Framerate</td>
                                <td>{frameRate} fps</td>
                                <td>
                                    <CopyButton toCopy={`${frameRate} fps`} />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </section>

            <section className="d-flex justify-content-center">
                <Button variant="outline-primary" onClick={onClickExportToCsv}>
                    Export to CSV
                </Button>
            </section>
        </div>
    );
}
